module.exports = "https://redage.akamaized.net/src/views/player/jobselector/assets/images/lock.svg";